import {useState} from "react";
import {Avatar, Button, List, Modal, Table, Tag, Typography} from "antd";
import {CSVLink} from "react-csv";
import {LinkOutlined, MessageOutlined} from "@ant-design/icons";
import {Link} from "react-router-dom";

export const DrugPDBList = ({ data, isLoading, name = '' }) => {
  const [showSentence, setShowSentence] = useState(false)
  const [item, setItem] = useState({})
  const columns = [
    {
      key: 'drug',
      dataIndex: 'drug',
      title: 'Drug',
      render: text => <Link to={`/drugs/${text.trim()}`}>{text}</Link>
    },
    {
      key: 'pdb',
      dataIndex: 'pdb',
      title: 'PDB',
      render: text => <Link to={`/PDBs/${text.trim()}`}>{text}</Link>
    },
    {
      key: 'action',
      title: 'Action',
      render: (_, item) => <Button onClick={() => {
        setItem(item)
        setShowSentence(true)
      }} icon={<MessageOutlined />} />
    }
  ]
  return(
    <>
      <Table columns={columns} loading={isLoading} dataSource={data} rowKey={r => r.id} scroll={{ x: true }} />
      <div style={{ textAlign: 'center' }}>
        <Button type="primary">
          <CSVLink filename={name ?? "drug_pdb.csv"} data={data}>Download CSV</CSVLink>
        </Button>
      </div>
      <Modal
        title={item.title}
        visible={showSentence}
        onOk={() => setShowSentence(false)}
        onCancel={() => setShowSentence(false)}
        centered
        destroyOnClose
        width={1000}
      >
        <Typography.Title level={4}>Abstract: </Typography.Title>
        <p>
          {item.abstract}
        </p>
        {item.doi !== '' ? <>
          <Typography.Title level={4}>DOI: </Typography.Title>
          <p>
            <a href={item.doi}>{item.doi}</a>
          </p>
        </> : ''}
      </Modal>
    </>
  )
}